import React from 'react';
import { connect } from 'react-redux';

import Wizard from 'components/ui/Wizard/Wizard';
import DocumentPortalInPerson from 'components/byesign/documentPortalInPerson';
import { openEditLease } from 'actions/LeaseDetailsActions';

const InPersonDocumentSigningWizard = ({
  showInPersonDocumentSigningWizard,
  closeInPersonDocumentSigningWizard,
  documentToSign,
  leaseDetails,
  openEditLease,
}) => {
  const {
    notice_of_increase_signature_request_id,
    notice_of_increase_in_person_access_token,
    certificate_of_service_signature_request_id,
    certificate_of_service_access_token,
    notice_of_increase_document_type,
  } = leaseDetails;

  const fetchLeaseDetails = async leaseId => {
    return await openEditLease(leaseId);
  };

  const closeWizardAndPullLeaseDetails = closeWizard => {
    closeWizard();
    fetchLeaseDetails(leaseDetails.id);
  };

  return (
    <Wizard
      showWizard={showInPersonDocumentSigningWizard}
      closeWizard={closeInPersonDocumentSigningWizard}
      hideOverflow
      isBackButtonVisible={false}
      wizardPages={[
        {
          component: props => (
            <DocumentPortalInPerson
              {...documentToSign}
              onContinue={() => props.setPageIndex(props.pageIndex + 1)}
              isModeInternal={true}
              document_uuid={notice_of_increase_signature_request_id}
              access_token={notice_of_increase_in_person_access_token}
              document_type={notice_of_increase_document_type}
              hideClose={true}
            />
          ),
        },
        {
          component: ({ closeWizard }) => (
            <DocumentPortalInPerson
              {...documentToSign}
              onContinue={() => closeWizardAndPullLeaseDetails(closeWizard)}
              isModeInternal={true}
              document_uuid={certificate_of_service_signature_request_id}
              access_token={certificate_of_service_access_token}
              document_type="CERTIFICATE_OF_SERVICE"
              hideClose={true}
            />
          ),
        },
      ]}
      componentWidth="62.5%"
    />
  );
};

const mapStateToProps = store => ({
  documentToSign: store.landlordApplications.documentToSign,
  leaseDetails: store.leaseDetails.leaseDetails,
});

const mapDispatchToProps = {
  openEditLease,
};

export default connect(mapStateToProps, mapDispatchToProps)(InPersonDocumentSigningWizard);
